<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :hide-default-footer="hideDefaultFooter"
    :header-props="headerProps"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    :item-key="itemKey"
    @click:row="atualizaSelecionado"
    >
      <template v-slot:header.checkbox="{ header }">
        <v-checkbox v-if="selecionarTudo === true"
        color="primary"
        :input-value="todosSelecionados"
        @change="selecionarTodos"
        ></v-checkbox>
      </template>
      <template v-slot:item.checkbox="props">
        <v-checkbox
        color="primary"
        :input-value="checkboxes.includes(props.item[itemKey])"
        readonly
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import dates from '@/utils/dates'

  export default {
    props: ['items', 'headers', 'search', 'opcoesPaginacao', 'value', 'itemKey', 'selecionarTudo', 'hideDefaultFooter', 'headerProps'],
    data: () => ({
      dates: dates,
      todosSelecionados: false,
      checkboxes: []
    }),
    watch: {
      value: function (val) {
        this.checkboxes = val.slice()
        console.log(this.checkboxes)
      },
      dataFormatada: function (val) {
        if (val === null) {
          this.data = ''
          this.$emit('input', undefined)
        }
      }
    },
    methods: {
      atualizaSelecionado (cidade) {
        if (this.checkboxes.includes(cidade[this.itemKey])) {
          this.checkboxes.splice(this.checkboxes.indexOf(cidade[this.itemKey]), 1)
        } else {
          this.checkboxes.push(cidade[this.itemKey])
        }
        this.$emit('input', this.checkboxes)
      },
      selecionarTodos () {
        this.todosSelecionados = !this.todosSelecionados
        if (this.todosSelecionados === true) {
          this.items.forEach(unidade => {
            this.checkboxes.push(unidade[this.itemKey])
          })
        } else {
          this.checkboxes.splice(0, this.checkboxes.length)
        }
        this.$emit('input', this.checkboxes)
      }
    },
    mounted () {
      this.checkboxes = this.value
    }
  }
</script>



// WEBPACK FOOTER //
// c-checkbox-table.vue?1d47c548